import { styled } from '@mui/material/styles'
import Box from '@/components/common/Box'
import { colors, typography, spacing, radius } from '@/styles/designTokens'

export const PillRoot = styled(Box)({
	display: 'inline-flex',
	alignItems: 'center',
	gap: spacing.sm,
	padding: `${spacing.sm}px ${spacing.lg}px`,
	borderRadius: radius.pill,
	border: `1px solid ${colors.border}`,
	backgroundColor: colors.surfaceWhite,
	flexShrink: 0,
})

export const PillLabel = styled('span')({
	fontFamily: typography.fontFamily,
	fontWeight: typography.fontWeightBold,
	fontSize: typography.fontSizeMd,
	lineHeight: typography.lineHeightMd,
	color: colors.textPrimary,
})
